import React, { Component } from "react";
import "./TransferOwnership.scss";
import ContactTab from "../../components/Tabs/ContactTab";
import { withRouter } from "react-router-dom";
import { Form, Input, Button, message, InputNumber, Upload } from "antd";

import { connect } from "react-redux";
import transferImg from "../../assets/contract.svg";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import { parsePhoneNumber } from "react-phone-number-input";
import { AddTransferOwnershipRequest } from "../../network/profile.network";
const { Dragger } = Upload;

class TransferOwnership extends Component {
  state = {
    activeTab: "1",
    btnLoading: false,
  };

  callback = (key) => {
    this.setState({ activeTab: key });
  };

  componentDidMount() {
    const {
      match: { params },
    } = this.props;
    //console.log(params);
    params.tab
      ? this.setState({ activeTab: params.tab })
      : this.setState({ activeTab: "1" });
  }

  onFinish = (values) => {
    console.log(values, "values");
    this.setState({ btnLoading: true });
    let body = new FormData();
    body.append("DocumentNumbe", values?.DocumentNumbe);
    body.append("MembershipNumber", values?.MembershipNumber);
    body.append("PhoneNumber", values?.PhoneNumber);
    body.append(
      "IdentityNumberImageFile",
      values?.IdentityNumberImageFile?.file?.originFileObj
    );
    AddTransferOwnershipRequest(
      body,
      (res) => {
        message.success("تمت إضافة الطلب بنجاح");
        this.setState({ btnLoading: false });
        setTimeout(() => {
          this.props.history.push({
            pathname: "/",
          });
        }, 500);
      },
      (error) => {
        this.setState({ btnLoading: false });
        message.error("حدث خطأ أثناء معالجة الطلب");
      }
    );
  };

  render() {
    const { btnLoading } = this.state;
    return (
      <div className="orders-wrapper">
        <div className="container">
          <div className="transfer-content-wrapper">
            <img src={transferImg} alt="" />
            <div className="form-holder auth-form-content">
              <Form name="basic" onFinish={this.onFinish}>
                {/* <Form.Item
              label={localization.EmailAddress[currentLang]}
              name="username"
              rules={[
                {
                  required: true,
                  message: `${localization.pleaseInput[currentLang]} ${localization.EmailAddress[currentLang]}`,
                },
              ]}
              className="input-holder"
            >
              <Input />
            </Form.Item> */}

                <Form.Item
                  label="رقم الجوال"
                  name="PhoneNumber"
                  className="input-holder"
                  rules={[
                    {
                      validator(_, value) {
                        let phoneValid = isValidPhoneNumber(value || "");
                        if (!value)
                          return Promise.reject("من فضلك ادخل رقم الجوال");
                        else if (!phoneValid)
                          return Promise.reject("رقم الجوال غير صحيح");
                        else return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <PhoneInput
                    international
                    countryCallingCodeEditable={false}
                    defaultCountry="SA"
                    // value={this.state.numberVal}
                    // onChange={(val) => this.setState({ numberVal: val })}
                  />
                </Form.Item>
                <Form.Item
                  label="رقم المستند"
                  name="DocumentNumbe"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: "من فضلك ادخل رقم المستند",
                    },
                  ]}
                >
                  <InputNumber min={0} />
                </Form.Item>
                <Form.Item
                  label="رقم العضوية"
                  name="MembershipNumber"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: "من فضلك ادخل رقم العضوية",
                    },
                  ]}
                >
                  <InputNumber min={0} />
                </Form.Item>
                <Form.Item
                  label="ملف الهوية"
                  name="IdentityNumberImageFile"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: "من فضلك ادخل ملف الهوية",
                    },
                  ]}
                >
                  <Dragger>
                    <p className="ant-upload-text">رقم الهوية للتحميل</p>
                  </Dragger>
                </Form.Item>
                <Button
                  size="large"
                  type="primary"
                  htmlType="submit"
                  block
                  loading={btnLoading}
                >
                  إرسال
                </Button>
              </Form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentLang: state.user.currentLang,
});

const OrdersWithRouter = withRouter(TransferOwnership);
export default connect(mapStateToProps)(OrdersWithRouter);
